// قائمة اللوحة في تطبيق الوالدين، بالعربية (انظر boardViewApp.nl.ts).
export const appBoardViewAr = {
    title: 'اللوحة',
    intro: 'هكذا تبدو اللوحة الآن، مباشرة. للمشاهدة فقط: اللمس يكون على اللوحة نفسها.',
    choose: 'اللوحة',
    lastSeen: 'آخر ظهور {when}',
    neverSeen: 'لم تظهر بعد',
    virtual: 'آيباد افتراضي',
    viewOnly: 'للمشاهدة فقط',
    loading: 'جارٍ تحميل اللوحة…',
    reconnecting: 'جارٍ إعادة الاتصال…',
    revoked: 'تم فصل هذه اللوحة.',
    failed: 'تعذّر عرض اللوحة.',
    retry: 'حاول مرة أخرى',
    frameTitle: 'اللوحة {name}، للمشاهدة فقط',
    parentsOnly: 'يمكن للوالدين فقط مشاهدة اللوحة هنا.',
    emptyTitle: 'لا توجد لوحة بعد',
    emptyText: 'اربط جهازًا لوحيًا وسترى اللوحة هنا.',
    emptyLink: 'ربط جهاز لوحي',
};
//# sourceMappingURL=boardViewApp.ar.js.map